@if (themeConfigLoaded()) {
    @switch (activeThemeSetting()) {
        @case (ThemeSettings.colorsSettings) {
            <sp-theme-colors-settings />
        }
        @case (ThemeSettings.buttonsSettings) {
            <sp-theme-buttons-settings />
        }
        @case (ThemeSettings.fontsSettings) {
            <sp-theme-fonts-settings [deviceMode]="deviceMode()" (deviceModeChange)="changeDeviceMode.emit($event)" />
        }
        @default {
            <sp-theme-preset-settings />
        }
    }
}
